import React, { useState, useEffect } from 'react';
import NpsService from '../../../services/resource/npsService';
import './styles.css'
import { useFormik } from 'formik';
import ButtonLoading from "../../../components/buttonLoading/buttonLoading";
import NpsTable from './NpsTable';
import Card from '../../../components/card/card';
import { toast } from 'react-toastify';
import NpsViewModal from './NpsViewModal';
import Pagination from '../../../components/pagination/pagination';
import DropDown from '../../../components/dropdown/dropdown';
import BranchService from '../../../services/resource/branchService';
import { useAuth } from '../../../context/authContext';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';
import fileDownload from 'js-file-download';
import MotoristaService from '../../../services/resource/motoristaService';

const initialValues = {
    id: "",
    branchName: "",
    branchId: "",
    clientName: "",
    employeeName: "",
    teamApproach: "",
    teamApproachNotes: "",
    storageCheck: "",
    storageCheckNotes: "",
    productQuality: "",
    productQualityNotes: "",
    issueResolution: "",
    issueResolutionNotes: "",
    deliveryTime: "",
    deliveryTimeNotes: "",
    npsScore: "",
    finalNotes: "",
    createdAt: "",
    romaneioId: "",
    date: "",
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
}

export default function NpsList() {
    const service = new NpsService();
    const branchService = new BranchService();
    const driverService = new MotoristaService();

    const navigate = useNavigate();

    const { user } = useAuth();
    const [nps, setNps] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [toggleAdvanced, setToggleAdvanced] = useState(true);
    const [selectedNps, setSelectedNps] = useState({});
    const [filters, setFilters] = useState({
        page: 0,
        size: 20,
    });

    const [pagination, setPagination] = useState({
        totalPages: 0,
        totalElements: 0
    });

    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [branches, setBranches] = useState([]);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const formik = useFormik({
        initialValues: initialValues
    });

    useEffect(() => {
        branchService.findAll().then(response => {
            setBranches(response.data)
        });
        formik.setFieldValue("branchId", user.branchid);

        loadNps({ ...formik.values, branchId: user.branchid });

        setCount(1);
    }, []);

    useEffect(() => {
        driverService.findAllByBranch(formik.values.branchId || 0).then(response => {
            setDrivers(response.data);
        })
    }, [formik.values.branchId])

    useEffect(() => {
        if (count > 0) {
            loadNps();
        }
    }, [filters.page]);

    const onSubmitNps = (e) => {
        e.preventDefault();
        loadNps();
    };

    const loadNps = (values = formik.values) => {
        setLoading(true);

        service.findAll(values, filters.size, filters.page).then(response => {
            setNps(response.data.content);
            setPagination({
                totalPages: response.data.totalPages,
                totalElements: response.data.totalElements
            });
        }).catch(error => {
            toast.error('Erro ao carregar dados de NPS');
        }).finally(() => {
            setTimeout(() => setLoading(false), 400);
        });
    };

    const viewNps = (data) => {
        setSelectedNps(data)
        setShowModal(true);
    }

    const openDeleteModal = (id) => {
        setSelectedNps(id);
        setShowModalDelete(true);
    };

    const deleteNps = () => {
        service.del(selectedNps.id, user.userid).then(() => {
            toast.success("NPS deletado com sucesso");
            setShowModalDelete(false);
            setShowModal(false);
            loadNps();
        }).catch(error => {
            toast.error(error.response.data.message)
        })
    }

    const downloadTheSheet = () => {
        const nomeArquivo = "relatorio_nps.xlsx";
        service.exportExcel(formik.values)
            .then((response) => {
                fileDownload(response.data, nomeArquivo);
            }).catch(e => {
                toast.error("Erro ao gerar relatório em Excel: ", e.response.data.message)
            })
    };

    return (
        <>
            <div className="w-full">
                <Card className="bg-white rounded-lg shadow p-4 mb-6 fade-in">
                    <form onSubmit={onSubmitNps}>
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-semibold text-gray-700">Consulta Avaliação NPS</h2>
                            <button type="button" id="toggleAdvanced" className="text-blue-600 hover:text-blue-800 flex items-center" onClick={() => setToggleAdvanced(!toggleAdvanced)}>
                                {toggleAdvanced ?
                                    <><i className="fas fa-sliders-h mr-2" /> Avançado</>
                                    :
                                    <><i className="fas fa-times mr-2" /> Fechar</>
                                }
                            </button>
                        </div>
                        <div className="flex flex-wrap gap-4">
                            <div className="flex-1 min-w-[200px]">
                                <DropDown
                                    id="cadastroBranchId"
                                    label="Buscar por Filial"
                                    label1="name"
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Todas"
                                    name="branchId"
                                    optional
                                    disabled={loading}
                                    value={formik.values.branchId}
                                    options={branches}
                                    invalid={formik.touched.branchId && formik.errors.branchId}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                />
                            </div>
                            <div className="flex-1">
                                <label for="startDate" className="block text-sm font-medium text-gray-700 mb-1">Data Inicial</label>
                                <input
                                    type="date"
                                    id="startDate"
                                    name="startDate"
                                    value={formik.values.startDate}
                                    onChange={formik.handleChange}
                                    className="w-full px-4 py-2 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 datepicker-input" />
                            </div>
                            <div className="flex-1">
                                <label for="startDate" className="block text-sm font-medium text-gray-700 mb-1">Data Final</label>
                                <input
                                    type="date"
                                    id="startDate"
                                    name="endDate"
                                    value={formik.values.endDate}
                                    onChange={formik.handleChange}
                                    className="w-full px-4 py-2 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 datepicker-input" />
                            </div>
                            {formik.values.branchId && drivers.length > 0 ?
                                <div className='flex-1'>
                                    <DropDown
                                        id="cadastroBranchId"
                                        label="Buscar por Motorista"
                                        label1="name"
                                        optionValue="id"
                                        optionLabel="id"
                                        optionLabel2="name"
                                        placeholder="Selecione um Motorista"
                                        name="driverId"
                                        optional
                                        disabled={loading}
                                        value={formik.values.driverId}
                                        options={drivers}
                                        onChange={formik.handleChange}
                                    />
                                </div>
                                :
                                <div className="flex-1">
                                    <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Cód Motorista</label>
                                    <div className="relative">
                                        <input
                                            id="driverId"
                                            type="text"
                                            name="driverId"
                                            placeholder="Digite o código..."
                                            className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formik.values.driverId}
                                            onChange={formik.handleChange}
                                        />
                                        <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                    </div>
                                </div>
                            }

                        </div>
                        {!toggleAdvanced &&
                            <div className="flex flex-wrap gap-4 mt-3 fade-in">

                                <div className="flex-1">
                                    <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Pedido</label>
                                    <div className="relative">
                                        <input
                                            type="searchCode"
                                            id="search"
                                            name="orderId"
                                            placeholder="Digite o pedido..."
                                            className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formik.values.orderId}
                                            onChange={formik.handleChange}
                                        />
                                        <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Cód. Cliente</label>
                                    <div className="relative">
                                        <input
                                            type="searchCode"
                                            id="search"
                                            name="clientCode"
                                            placeholder="Digite o código..."
                                            className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formik.values.clientCode}
                                            onChange={formik.handleChange}
                                        />
                                        <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Criador</label>
                                    <div className="relative">
                                        <input
                                            id="employeeName"
                                            type="text"
                                            name="employeeName"
                                            placeholder="Digite o código..."
                                            className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formik.values.employeeName}
                                            onChange={formik.handleChange}
                                        />
                                        <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Nome Motorista</label>
                                    <div className="relative">
                                        <input
                                            id="driverName"
                                            type="text"
                                            name="driverName"
                                            placeholder="Digite o nome do motorista..."
                                            className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formik.values.driverName}
                                            onChange={formik.handleChange}
                                        />
                                        <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                    </div>
                                </div>

                                <div className="flex-1">
                                    <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Romaneio</label>
                                    <div className="relative">
                                        <input
                                            id="searchName"
                                            type="text"
                                            name="romaneioId"
                                            placeholder="Digite o nome do motorista..."
                                            className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formik.values.romaneioId}
                                            onChange={formik.handleChange}
                                        />
                                        <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                    </div>
                                </div>

                            </div>
                        }
                        <div className="flex justify-between   mt-3">
                            <div className='flex flex-wrap gap-2'>
                                <div className="flex items-end">
                                    <ButtonLoading for="file-upload"
                                        type="submit"
                                        label="Pesquisar"
                                        icon="fas fa-search"
                                        color="indigo"
                                    />
                                </div>
                                <div className="flex items-end">
                                    <ButtonLoading
                                        for="file-upload"
                                        label="Nova Avaliação"
                                        type="button"
                                        color="green"
                                        icon="bi bi-clipboard-check"
                                        onClick={() => navigate("/nps/nova-avaliacao")}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-wrap gap-2'>
                                <div className="flex items-end">
                                    <ButtonLoading
                                        for="file-upload"
                                        label="Exportar em Excel"
                                        disabled={pagination.totalElements == 0}
                                        type="button"
                                        color="green"
                                        icon="bi bi-file-earmark-excel-fill"
                                        onClick={downloadTheSheet}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </Card>

                {/* <!-- NPS List --> */}
                {loading ? (
                    <div className="text-center py-10">
                        <i className="fas fa-spinner fa-spin text-4xl text-indigo-600 mb-4" />
                        <p className="text-gray-600">Carregando nps...</p>
                    </div>
                ) : pagination.totalElements === 0 ? (
                    <div className="text-center py-10">
                        <i className="fas fa-inbox text-4xl text-gray-400 mb-4" />
                        <p className="text-gray-600">Nenhuma Avaliação NPS encontrado</p>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow overflow-hidden fade-in">
                        <NpsTable
                            data={nps}
                            onView={(item) => viewNps(item)}
                            onDelete={(item) => openDeleteModal(item)}
                        />
                        {/* <!-- Pagination --> */}
                        <Pagination
                            page={filters.page}
                            size={filters.size}
                            pageSize={filters.size}
                            onPageSize={
                                (newSize) =>
                                    setFilters((prev) => ({ ...prev, size: newSize }))

                            }
                            totalPages={pagination.totalPages}
                            totalElements={pagination.totalElements}
                            onPageChange={(newPage) =>
                                setFilters((prev) => ({ ...prev, page: newPage }))
                            }
                        />
                    </div>
                )}
            </div >

            {showModal && (
                <NpsViewModal
                    onDelete={(item) => openDeleteModal(item)}
                    onClose={() => setShowModal(false)}
                    nps={selectedNps}
                />
            )}

            {showModalDelete && (
                // <div id="deleteModal" className="modal fixed inset-0 z-50 overflow-y-auto">
                <div id="deleteModal" className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                        </div>

                        <span className="hidden lg:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div className="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="lg:flex lg:items-start">
                                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                        <i className="fas fa-exclamation-triangle text-red-600"></i>
                                    </div>
                                    <div className="text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <h3 className="lg:text-left text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                            Deletar Avaliação de NPS
                                        </h3>
                                        <div className="mt-2">
                                            <p className="lg:text-left text-sm text-gray-500">
                                                Tem certeza de que deseja excluir este feedback do NPS? Esta ação não pode ser desfeita.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    id="confirmDeleteBtn"
                                    onClick={deleteNps}
                                    className="mt-3 w-full inline-flex justify-center rounded-md border border-red-300 shadow-sm px-4 py-2 bg-red-600 text-white font-medium text-white-700 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                                    Deletar
                                </button>
                                <button type="button" id="cancelDeleteBtn" onClick={() => setShowModalDelete(false)} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}